import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { IListFetcher } from '../../ts/fetchers/IListFetcher';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { mapRecTypeToBaseType } from '../../ts/models/ContentType';
import { IViewRecommendationInfo } from '../../ts/models/IViewRecommendationInfo';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { GetRecommendedViewsRequest } from '../../ts/ServerApi/requests/GetRecommendedViewsRequest';
import { HideRecommendationRequest } from '../../ts/ServerApi/requests/HideRecommendationRequest';
import { UndoHideRecommendationRequest } from '../../ts/ServerApi/requests/UndoHideRecommendationRequest';

export namespace ViewRecommendations {

  let getRecommendedViews: IListFetcher<IViewRecommendationInfo> = null;

  export function viewRecommendations(): ResourceQuery<IViewRecommendationInfo> {
    if (getRecommendedViews === null) {
      getRecommendedViews = new WebClientListResourceFetcher(GetRecommendedViewsRequest, ServerApiMapper.vizRecommendations);
    }
    return new ResourceQuery(getRecommendedViews);
  }

  export function hideRecommendation(objectType: string, objectId: string): Promise<IResult> {
    return WebHttpClient.sendRequest(new HideRecommendationRequest({
      objectType: mapRecTypeToBaseType(objectType),
      objectId: objectId
    }));
  }

  export function undoHideRecommendation(objectType: string, objectId: string): Promise<IResult> {
    return WebHttpClient.sendRequest(new UndoHideRecommendationRequest({
      objectType: mapRecTypeToBaseType(objectType),
      objectId: objectId
    }));
  }

}

export type ViewRecommendations = typeof ViewRecommendations;
